export default __webpack_public_path__ + "static/media/image-ph-health-home-m.62ea16db.png";